import { Box, FlexBox } from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import styles from './aiLoadingState.module.scss';

type AiLoadingStateProps = {
  /** The loading label, e.g. `Translating` */
  label?: string;
};

/**
 * Represents the component for displaying the loading state for an AI related
 * task.
 */
export const AiLoadingState = (props: AiLoadingStateProps): JSX.Element => {
  const dots = (
    <div
      className={classnames(styles.dots, { [styles.withLabel]: !!props.label })}
    >
      {Array(3)
        .fill(null)
        .map((_, index) => (
          <div key={index} className={styles.dot} />
        ))}
    </div>
  );

  return (
    <FlexBox gap="200" alignItems="center">
      <div className={styles.icon}>
        <svg
          className={classnames(styles.star, styles.large)}
          viewBox="0 0 12.5 12.5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M.31 5.782 4.29 4.29 5.781.31a.5.5 0 0 1 .936 0L8.21 4.29l3.98 1.492a.5.5 0 0 1 0 .936L8.21 8.21l-1.492 3.98a.501.501 0 0 1-.936 0L4.29 8.21.31 6.718a.501.501 0 0 1 0-.936Zm1.6.468 2.943-1.104a.5.5 0 0 0 .293-.292L6.25 1.91l1.104 2.944c.05.135.157.242.292.292L10.59 6.25 7.646 7.354a.5.5 0 0 0-.292.293L6.25 10.59 5.146 7.647a.504.504 0 0 0-.293-.293L1.91 6.25Z"
          />
        </svg>
        <svg
          className={classnames(styles.star, styles.small)}
          viewBox="0 0 6 6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M3.505.505v1.99h1.99c.277 0 .505.228.505.505a.508.508 0 0 1-.505.505h-1.99v1.99A.507.507 0 0 1 3 6a.508.508 0 0 1-.505-.505v-1.99H.505A.508.508 0 0 1 0 3c0-.277.228-.505.505-.505h1.99V.505C2.495.228 2.723 0 3 0s.505.228.505.505Z"
          />
        </svg>
      </div>

      {props.label ? (
        <FlexBox gap="100" alignItems="baseline">
          <Box>{props.label}</Box>
          {dots}
        </FlexBox>
      ) : (
        dots
      )}
    </FlexBox>
  );
};
